import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'
import type { AthleticsStudentRecord } from '@/types/enrollments'

// GET /ajax/athletics/students/{studentAccountId}/record (DTA-799 round 10):
// the student's violations (office-owned, read-only for families). A 403
// is not a dead session, so the auth redirect is suppressed and the caller
// shows the server's reason.
export const athleticsStudentRecord = async (
  studentAccountId: number
): Promise<AthleticsStudentRecord> => {
  const response = await new Request(undefined, 'json', { redirectOnForbidden: false }).get(
    '/ajax/athletics/students/' + studentAccountId + '/record'
  )
  const data = response.data ?? {}
  return Util.Obj.keysToCamel({
    schema_version: data.schema_version ?? 1,
    violations: data.violations ?? []
  }) as AthleticsStudentRecord
}
